import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import DINBlack from "./DINNextLTPro-Black.woff2";

export const ComicShannsFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: DINBlack,
    descriptors: {
      unicodeRange: "U+0020-10FFFF",
      weight: "900",
    },
  },
];
